export const statsStyles = theme => ({
    root: {
        display: 'inline-flex',
        paddingTop: '5px',
    },
    stat: {
        paddingRight: theme.spacing(2),
        fontWeight: 500,
    },
});
